import type { DeepPartial } from '@luna/utils-ts';

import type { Search } from '../../types/Search';

export const searchROFeatureConfig: DeepPartial<Search> = {
    countryProductId: 'INVESTMENTS',
    displayIssuerForShares: true,
    extraGroupTypeKeys: ['PREMIUM_DEPOSIT'],
    fetchDocuments: true,
    marketDataPortalLanguageUrls: {
        en: 'https://www.erste-am.ro/en/investors-information/our-funds/fund-search',
        ro: 'https://www.erste-am.ro/ro/informatii-investitori/fondurile-noastre/cauta-fond',
    },
    showExperienceProfileMissingTooltip: true,
    showPreorderScreenOnSuggestionClick: true,
    bondOfferingUrl:
        'https://www.bcr.ro/content/dam/ro/bcr/www_bcr_ro/new_bcr_investitii/obligatiuni-guvernamentale-din-Romania/Cotatii_titluri.pdf',
    fundOfferingUrl:
        'https://www.erste-am.ro/ro/informatii-investitori/fondurile-noastre/cauta-fond',
};
